<template>
    <div class="home-box">
        <v-progress-linear v-if="loading" indeterminate color="orange"></v-progress-linear>
        <v-card>
            <v-card-title dark>
                <h3 class="ma-2">Project Theme Wise Reports</h3>
                <v-spacer></v-spacer>
                <v-select v-model="governor_theme_id" :items="themeList" :item-text="'theme'" :item-value="'uuid'"
                    label="Theme" dense outlined></v-select>
                <v-spacer></v-spacer>
                <v-btn @click="loadSummaryList()" :disabled="loading || !governor_theme_id">Download</v-btn>

            </v-card-title>

        </v-card>

    </div>
</template>

<script>
import MonthsList from "@/utility/months.json";
import { ProjectService } from "@/services/project-service";
import { CommonService } from "../../../services/common-service";
import { checkError } from "@/config/errors.js";
import { fileService } from "@/config/file-service.js";

export default {
    name: "ActivityClubWiseReport",
    components: {},

    data: function () {
        return {
            loading: false,
            filterBtnTTip: false,
            month: "",
            months: MonthsList,
            list: [],
            clubId: "",
            role: localStorage.getItem("role"),
            errors: null,
            successMsg: "",
            snackbar: false,
            governor_theme_id: null,
            themeList: []
        };
    },

    mounted() {
        this.$store.dispatch("auth/getProfile");
        this.getGovernorThemes();
    },


    methods: {
        getGovernorThemes() {
            if (this.uuid !== null) {
                this.loading = true;
                CommonService.getGovernorThemes()
                    .then((response) => {
                        this.loading = false;
                        if (response.data.data) {
                            this.themeList = response.data.data;
                        }
                    })
                    .catch((error) => {
                        this.loading = false;
                        this.themeList = [];
                        let data = error.response.data;
                        let errorOutput = checkError.errorFormatting(data);
                        this.errors = errorOutput;
                    });
            }
        },



        loadSummaryList() {
            if (this.governor_theme_id) {
                this.loading = true;
                ProjectService.downloadProjectSummaryReports(this.governor_theme_id, {
                    responseType: "blob",
                })
                    .then((response) => {
                        this.loading = false;
                        if (response.data) {
                            this.list = response.data;
                            this.loading = false;
                            let fileType = response.headers["content-type"];
                            let extension = "csv";
                            fileService.downloadFile(
                                response.data,
                                fileType,
                                extension,
                                "project-summary-" + this.governor_theme_id
                            );
                        }
                    })
                    .catch((error) => {
                        this.loading = false;
                        let data = error.response.data;
                        let errorOutput = checkError.errorFormatting(data);
                        this.errors = errorOutput;
                        this.list = [];
                    });
            }

        }


    },
};
</script>
<style>
/* td.rotate {        
height: 400px;
white-space: nowrap;
min-width: 40px;
}

td.rotate-0 {
    min-width: 120px;
}



td.rotate>div {
    transform:
    translate(25px, 51px)       
    rotate(270deg);
    width: 30px;
}

td.rotate>div>span {
    border-bottom: 1px solid #ccc;
    padding: 5px 5px;
    font-size: 11px;
    max-height: 100px;
}

*/
</style>